import ScrollContainer from "components/ScrollContainer/ScrollContainer"

export default ScrollContainer
